module.exports = __webpack_public_path__ + "static/media/nisai.3c31d177.png";